export default __webpack_public_path__ + "static/media/uniswap-uni-logo 1.9884b1ad.svg";